var map = {
	"./0.png": 5844,
	"./1.png": 9407,
	"./10.png": 9504,
	"./11.png": 3016,
	"./12.png": 3895,
	"./13.png": 795,
	"./14.png": 2289,
	"./15.png": 5343,
	"./16.png": 6946,
	"./17.png": 9415,
	"./18.png": 4183,
	"./19.png": 6047,
	"./2.png": 1976,
	"./20.png": 5172,
	"./2B.png": 2732,
	"./2G.png": 9350,
	"./2R.png": 1589,
	"./2U.png": 5518,
	"./2W.png": 4360,
	"./3.png": 3797,
	"./4.png": 1253,
	"./5.png": 5880,
	"./6.png": 270,
	"./7.png": 9122,
	"./8.png": 1814,
	"./9.png": 593,
	"./B.png": 1735,
	"./BG.png": 7067,
	"./BP.png": 9094,
	"./BR.png": 9664,
	"./C.png": 2273,
	"./G.png": 6608,
	"./GP.png": 3727,
	"./GU.png": 6026,
	"./GW.png": 7065,
	"./R.png": 5227,
	"./RG.png": 3875,
	"./RP.png": 6379,
	"./RW.png": 9694,
	"./S.png": 8143,
	"./U.png": 9944,
	"./UB.png": 6586,
	"./UP.png": 6335,
	"./UR.png": 1432,
	"./W.png": 7757,
	"./WB.png": 4275,
	"./WP.png": 9906,
	"./WU.png": 9295,
	"./X.png": 9317
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4084;